import { render, staticRenderFns } from "./courtInstallation.vue?vue&type=template&id=954a76a8&"
import script from "./courtInstallation.vue?vue&type=script&lang=ts&"
export * from "./courtInstallation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "courtInstallation.vue"
export default component.exports